function init () {
  const button = document.querySelector('#hamburger')

  if (!button) {
    return
  }

  button.addEventListener('click', () => {
    button.classList.toggle('is-active')
    document.body.classList.toggle('has-menu')
  })
}

export default init
